
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hashtags",
      function () {
        return require("private-next-pages/hashtags/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hashtags"])
      });
    }
  